import {
  useInfiniteQuery,
  type UseInfiniteQueryResult,
  type InfiniteData,
} from '@tanstack/react-query'

import type { ActivitiesView } from '@front/type/activity'
import type { PaginatedAdminWorkerMonthActivities } from '@front/type/admin'
import type { CustomError } from '@front/type/api'

import { axiosGet } from '../logic/axios/wrappers/axios.get.wrapper'

import { adminWorkerUrl } from './config'

export const useAdminWorkerActivitiesKey = 'get-admin-worker-activities'

interface AdminWorkerActivities {
  idWorker: number
  idInstitution: number
  view: ActivitiesView
}

export const useAdminWorkerActivities = ({
  idWorker,
  idInstitution,
  view,
}: AdminWorkerActivities): UseInfiniteQueryResult<
  InfiniteData<PaginatedAdminWorkerMonthActivities>,
  CustomError
> => {
  return useInfiniteQuery({
    queryKey: [useAdminWorkerActivitiesKey, idWorker, idInstitution, view],
    queryFn: async ({ pageParam }) =>
      axiosGet<PaginatedAdminWorkerMonthActivities>(
        `${adminWorkerUrl}/${idWorker}/activity?page=${pageParam}&view=${view}&idInstitution=${idInstitution}`,
      ),

    initialPageParam: 1,
    getNextPageParam: (lastPage) => lastPage.nextPage,
  })
}
